import {Card} from 'antd';
import React, {FC, useEffect} from 'react';
import {useDispatch} from 'react-redux';
import {useLocation} from 'react-router-dom';

import {IDirectoryEntityMeta, loadMetadata, selectMetadata} from 'entities/metadata';
import {
    selectEntityData,
    IDirectoryEntityData,
    loadDirectoryData as loadDirectoryDataAction,
} from 'modules/data';
import {setData} from 'modules/data/data-actions';
import {EEntityType} from 'shared/constants/entities';
import {useAppSelector} from 'store/config/hooks';

import {Spinner} from '../spinner';
import {SubsectionSwitcher} from '../subsection-switcher/subsection-switcher';
import {TableAction} from '../table/action';
import {Directory} from './directory';

interface IDirectoryContainerProps {
    entityName: string;
    url: string;
}

export const DirectoryContainer: FC<IDirectoryContainerProps> = ({
    entityName,
    url,
}: IDirectoryContainerProps) => {
    const location = useLocation();
    const dispatch = useDispatch();
    const metadata = useAppSelector(selectMetadata(entityName, EEntityType.TABS)) as IDirectoryEntityMeta;
    const data = useAppSelector(selectEntityData(entityName, EEntityType.TABS)) as IDirectoryEntityData;
    const isLoaded = metadata?.fields && data?.rows;

    const setCurrentTab = (tab: string) => {
        dispatch(setData({entityName, entityType: EEntityType.TABS, data: {tab}}));
    };

    useEffect(() => {
        if (!metadata) {
            dispatch(loadMetadata(entityName, EEntityType.TABS));
        } else if (!data || !data?.rows) {
            dispatch(loadDirectoryDataAction(entityName));
        }
    }, [data, entityName, metadata]);

    useEffect(() => {
        if (data?.rows && data.rows.length) {
            setCurrentTab(data.rows[0][metadata.linkField || 'id'] as string);
        }
    }, [data?.rows]);

    return isLoaded ? (
        <Card
            title={metadata.title}
            className="directory-container"
        >
            {metadata?.actions?.length || metadata?.subsections?.length
                ? (
                    <div className="directory-container__actions">
                        {Boolean(metadata?.actions?.length) && metadata?.actions && metadata.actions.map(action => (
                            <TableAction
                                meta={action}
                                key={action.actionTitle}
                                entityName={entityName}
                                url={url}
                                link={`${metadata.name}/${data?.tab || ''}`}
                            />
                        ))}
                        {metadata?.subsections && Boolean(metadata?.subsections?.length) && (
                            <SubsectionSwitcher
                                entityName={entityName}
                                location={location.pathname}
                                subsections={metadata.subsections}
                            />
                        )}
                    </div>
                ) : null}
            <Directory
                url={url}
                metadata={metadata}
                data={data}
                currentTab={data?.tab || ''}
                setCurrentTab={setCurrentTab}
            />
        </Card>
    ) : <Spinner />;
};
